<template>




    <v-dialog
      v-model="localDialog"
      max-width="500"
      dark black
    >
      <s-card class="grey darken-3">
        <span class=" d-block headline white--text mt-4 mb-4" :class="[$vuetify.breakpoint.mdAndUp ? 'mb-0 px-3 ' : 'px-5 mb-2']">
          {{ action == null ? '' : action.label }}
        </span>
        <v-simple-table dense class="pa-2">
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Actie</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.label }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Prioriteit</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.priority }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Status</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.state }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Datum</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : toDateTime(action.date) }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Laatst geupdate</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : toDateTime(action.date) }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">EAN</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.ean }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Energietype</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.type }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Categorie</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.category }}</td>
            </tr>
            <tr>
              <td class="pa-3 font-weight-bold" style="width: 50% !important;">Adres</td>
              <td class="pa-3" style="width: 50% !important;">{{ action == null ? '' : action.postal }} {{ action == null ? '' : action.number }} {{ action == null ? '' : action.addition }}</td>
            </tr>

          </tbody>
        </template>
        </v-simple-table>
        <v-card-actions class="pa-3 grey darken-2">
        <v-spacer></v-spacer>

          <v-btn 
            @click="markAsInProgress" v-if="action != null && action.state == 'open' && action.action == null">
            Markeer als in behandeling
          </v-btn>

          <v-btn 
            @click="doAction" v-if="action != null && action.state == 'open' && action.action != null">
            {{ action.action.btn }}
          </v-btn>

          <v-btn
            color="primary" to="" class="text-none text-none"
            v-html="'Sluiten'" @click="localDialog=false;"
          ></v-btn>

        </v-card-actions>
      </s-card>
      <v-dialog v-model="confirm" persistent max-width="290" v-if="action != null && action.state == 'open' && action.action != null && action.action.confirm != null">
        <v-card>
          <v-card-title class="headline">
            {{ action.action.confirm }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="text-none text-none"
              @click="confirm = false"
            >
              Nee
            </v-btn>
            <v-btn
              color="primary"
              class="text-none text-none"
              @click="sendAction"
            >
              Ja
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="prompt" persistent max-width="290" v-if="action != null && action.state == 'open' && action.action != null && action.action.prompt != null">
        <v-card>
          <v-card-title class="headline">
            {{ action.action.prompt }}
            <v-spacer></v-spacer>
            <v-simple-table dense class="pa-2">
            <template v-slot:default>
              <tbody>
                <tr v-for="(item, i) in action.action.fields" :key="i">
                  <td class="pa-3 font-weight-bold" style="width: 50% !important;">{{ item }}</td>
                  <td class="pa-3" style="width: 50% !important;"><input type="text" :name="item" :placeholder="item" v-model="fields[item]" /></td>
                </tr>
              </tbody>
            </template>
            </v-simple-table>
          </v-card-title>
          <v-card-actions class="pa-3 grey darken-2">
            <v-spacer></v-spacer>
            <v-btn
              class="text-none text-none"
              @click="prompt = false"
            >
              Annuleren
            </v-btn>
            <v-btn
              color="primary"
              class="text-none text-none"
              @click="sendPostAction"
            >
              Opslaan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
</template>
<script>
export default {
    props:['action', 'dialog'],
  data() {
      return {
        confirm: false,
        prompt: false,
        fields: {},
      };
  },
  methods:
  {
    markAsInProgress()
    {
        let data = {request: {state:2}, action:this.action};
        this.$store.dispatch('updateAction', data).then
        ((data) => {
          this.$emit('actionUpdated', data.data); 
      });
    },
    doAction()
    {
      if(this.action.action.confirm != undefined && this.action.action.confirm != null)
      {
        this.confirm = true;
      }
      else if(this.action.action.prompt != undefined && this.action.action.prompt != null)
      {
        this.prompt = true;
      }
      else
      {
        this.sendAction();
      }
    },
    sendAction()
    {
        this.confirm = false;
        
        axios.get(this.action.action.action, { responseType: 'json'}).then
        ((data) => {
          this.action.state = 'voltooid';
          this.$emit('actionUpdated', this.action); 
        }).catch(function (error){
          });
    },
    sendPostAction()
    {
      this.prompt = false;
      let data = {};
      for(let i in this.action.action.fields)
      {
        data[this.action.action.fields[i]] = this.fields[this.action.action.fields[i]];
      }
      axios.post(this.action.action.action, data, { responseType: 'json'}).then
        ((data) => {
          this.action.state = 'voltooid';
          this.$emit('actionUpdated', this.action); 
        }).catch(function (error){
          });
    }
  },
  computed:
  {
    localDialog:
    {
        get: function(){ return this.dialog },
        set: function(value){ this.$emit('update:dialog', value) }
    }
  }
};
</script>